export enum SignerType {
  FIXED = 'fixed',
  DYNAMIC = 'dynamic',
}
